import React from 'react';

import classes from './ReportSummaryContent.module.scss';

interface Props {
    content: string;
}

export const ReportSummaryContent = ({ content }: Props) => {
    return (
        <div className={classes.ReportSummaryContent}>
            <div className={classes.content} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};
